import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BlendingAccordionModule } from './accordion';
import { ViewBlendStructureDialogComponent } from './view-blend-structure/view-blend-structure-dialog/view-blend-structure-dialog.component';
import { ViewBlendStructureTableComponent } from './view-blend-structure/view-blend-structure-table/view-blend-structure-table.component';

@NgModule({
	imports: [CommonModule, GenericDirectivesModule, CwpNgFrameworkModule, SharedModule, NgxSkeletonLoaderModule, BlendingAccordionModule],
	declarations: [ViewBlendStructureDialogComponent, ViewBlendStructureTableComponent],
	exports: [ViewBlendStructureDialogComponent]
})
export class BlendingModule { }
